import React from 'react';

type Props = {
  children: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  className?: string;
  style?: React.CSSProperties;
};

const PrimaryButton = ({ children, onClick, disabled, type = 'button', className, style }: Props) => (
  <button
    onClick={onClick}
    disabled={disabled}
    type={type}
    className={className}
    style={style}
  >
    {children}
  </button>
);

export default PrimaryButton;
